import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { displayWithCurrency } from '../../../utility/currency'
import { certificationPath, certificationStatus, coverImageUrl } from '../../../utility/coachCertification'

import classes from './CertificationCard.module.scss'

const CertificationCard = ({ certification }) => {
  const { t } = useTranslation()
  const status = certificationStatus(certification)
  const { price } = certification
  const priceLabel = price ? displayWithCurrency(price.amount, price.currency) : t('portal.certification.priceCard.noPrice')

  return (
    <Link to={certificationPath(certification.id)} className={classes.card}>
      <div className={classes.cover}>
        <img src={coverImageUrl(certification)} alt='' className={classes.image} />
        <span className={classes.level}>{t('portal.certification.list.level', { level: certification.level })}</span>
      </div>
      <div className={classes.body}>
        <div className={classes.name}>{certification.name}</div>
        {certification.description && <p className={classes.description}>{certification.description}</p>}
        <div className={classNames('d-flex align-items-center justify-content-between', classes.footer)}>
          <span className={classes.meta}>{t('portal.certification.details.lessons', { count: certification.lessonsCount })}</span>
          {status ? (
            <span className={classNames(classes.status, { [classes.statusCompleted]: ['completed', 'certified'].includes(status) })}>
              {t(`portal.certification.list.status.${status}`)}
            </span>
          ) : (
            <span className={classes.price}>{priceLabel}</span>
          )}
        </div>
      </div>
    </Link>
  )
}

CertificationCard.propTypes = {
  certification: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    level: PropTypes.number.isRequired,
    description: PropTypes.string,
    lessonsCount: PropTypes.number.isRequired,
    enrollmentStatus: PropTypes.string,
    certified: PropTypes.bool,
    coverImage: PropTypes.shape({ largeFileUrl: PropTypes.string }),
    price: PropTypes.shape({
      amount: PropTypes.string.isRequired,
      currency: PropTypes.shape({ code: PropTypes.string.isRequired, symbol: PropTypes.string.isRequired }).isRequired,
    }),
  }).isRequired,
}

export default CertificationCard
